// Dependencies
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React, { FC, ReactElement, useEffect } from 'react';
import {
    addMonths,
    addWeeks,
    format,
    isSameMonth,
    isSameISOWeek,
    subMonths,
    subWeeks,
} from 'date-fns';
// Core & Lab
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
// Components
import ChannelManagerStockCurrentDay from './channelManagerStockCurrentDay';
// Actions
import { toggleStocksViewMode, updateStocksCurrentMonth } from './redux/reducer';
// Types
import { AppState } from '../../reducers';

const ChannelManagerStockAction: FC = (): ReactElement | null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stocks_current_month = useSelector((state: AppState) => state.channelManager.stocks_current_month);
    const stocks_display_mode = useSelector((state: AppState) => state.channelManager.stocks_display_mode);
    const contract_selected = useSelector((state: AppState) => state.channelManager.contract_selected);
    const onPrevMonth = () => {
        if (stocks_current_month !== null) {
            dispatch(updateStocksCurrentMonth(subMonths(new Date(stocks_current_month), 1)));
        }
    };
    const onNextMonth = () => {
        if (stocks_current_month !== null) {
            dispatch(updateStocksCurrentMonth(addMonths(new Date(stocks_current_month), 1)));
        }
    };
    const onPrevWeek = () => {
        if (stocks_current_month !== null) {
            dispatch(updateStocksCurrentMonth(subWeeks(new Date(stocks_current_month), 1)));
        }
    };
    const onNextWeek = () => {
        if (stocks_current_month !== null) {
            dispatch(updateStocksCurrentMonth(addWeeks(new Date(stocks_current_month), 1)));
        }
    };
    const onToggleViewMode = () => {
        dispatch(toggleStocksViewMode());
    };
    useEffect(() => {
        if (stocks_current_month !== null) {
            const container = document.getElementById('manual-accommodation-stocks');
            let date;
            if (stocks_display_mode === 0) {
                date = document.getElementById(`manual-accommodation-stocks-month-${format(stocks_current_month, 'M-yyyy')}`);
            } else {
                date = document.getElementById(`manual-accommodation-stocks-week-${format(stocks_current_month, 'w-yyyy')}`);
            }
            const name = document.getElementById('manual-accommodation-stocks-name');
            if (container !== null && date !== null && name !== null) {
                container.scrollLeft = date.offsetLeft - name.offsetWidth;
            }
        }
    }, [stocks_current_month]);
    return (
        <Grid item container xs={ 12 } spacing={ 2 } justifyContent={ 'space-between' } alignItems={ 'center' }>
            {
                stocks_display_mode === 0 ? (
                    <Grid item container xs spacing={ 2 }>
                        <Grid item>
                            <Button disabled={ contract_selected?.start_date && stocks_current_month !== null ? isSameMonth(new Date(contract_selected.start_date), new Date(stocks_current_month)) : true } onClick={ onPrevMonth }>{ t('shared.prev-month') }</Button>
                        </Grid>
                        <Grid item>
                            <Button disabled={ contract_selected?.end_date && stocks_current_month !== null ? isSameMonth(new Date(contract_selected.end_date), new Date(stocks_current_month)) : true } onClick={ onNextMonth }>{ t('shared.next-month') }</Button>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid item container xs spacing={ 2 }>
                        <Grid item>
                            <Button disabled={ contract_selected?.start_date && stocks_current_month !== null ? isSameISOWeek(new Date(contract_selected.start_date), new Date(stocks_current_month)) : true } onClick={ onPrevWeek }>{ t('shared.prev-week') }</Button>
                        </Grid>
                        <Grid item>
                            <Button disabled={ contract_selected?.end_date && stocks_current_month !== null ? isSameISOWeek(new Date(contract_selected.end_date), new Date(stocks_current_month)) : true } onClick={ onNextWeek }>{ t('shared.next-week') }</Button>
                        </Grid>
                    </Grid>
                )
            }
            <Grid item container xs spacing={ 2 } justifyContent={ 'center' }>
                <Grid item>
                    <ChannelManagerStockCurrentDay/>
                </Grid>
            </Grid>
            <Grid item container xs spacing={ 2 } justifyContent={ 'flex-end' }>
                <Grid item>
                    <Button disabled={ stocks_display_mode === 0 } onClick={ onToggleViewMode }>{ t('shared.month-view') }</Button>
                </Grid>
                <Grid item>
                    <Button disabled={ stocks_display_mode === 1 } onClick={ onToggleViewMode }>{ t('shared.week-view') }</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ChannelManagerStockAction;